import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.css";
import "./i18n";
import i18n from "i18next";
import App from "./app.jsx";

const root = document.getElementById("root");
const currentLocale = window.location.pathname.split("/")[1];
const isTraditionalChinese = currentLocale === "zh-tw" || i18n.language === "zh-tw";

const revealApp = () => {
  document.body.classList.add("app-ready");
  ReactDOM.render(<App />, root);
};

const waitForFont = async () => {
  if (!isTraditionalChinese || !document.fonts) {
    return;
  }

  const loadFont = document.fonts.load('16px "BpmfZihiKaiStd"');
  const timeout = new Promise((resolve) => setTimeout(resolve, 1200));

  try {
    await Promise.race([loadFont, timeout]);
  } catch (error) {
    // If font loading fails, render anyway rather than blocking the page.
  }
};

waitForFont().then(revealApp).catch(revealApp);
